import { render, staticRenderFns } from "./DemoGridArticles.vue?vue&type=template&id=67a24ac1&"
import script from "./DemoGridArticles.vue?vue&type=script&lang=js&"
export * from "./DemoGridArticles.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports